import { render, staticRenderFns } from "./PaymentsDetail.vue?vue&type=template&id=4eb35710&scoped=true&"
import script from "./PaymentsDetail.vue?vue&type=script&lang=ts&"
export * from "./PaymentsDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentsDetail.vue?vue&type=style&index=0&id=4eb35710&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb35710",
  null
  
)

export default component.exports